module.exports = __webpack_public_path__ + "static/media/Bane.107f2108.png";